import {State, StateData} from "./state";
import {Register, RegisterData} from "./register";

export interface NetworkData {
    initial: string
    states: {[key: string]: StateData}
    registers: {[key:string]: RegisterData}
}

export class Network {
    public readonly initial: string;
    public readonly registers: Map<string, Register>;
    public readonly states: Map<string, State>;

    constructor(data: NetworkData) {
        this.initial = data.initial;
        this.registers = new Map<string, Register>();
        this.states = new Map<string, State>();
        if (data.registers) {
            const registers = data.registers;

            Object.keys(registers).forEach(key => this.registers.set(key, new Register(registers[key])));
        }
        Object.keys(data.states).forEach(key => this.states.set(key, new State(data.states[key])));
    }

	serialise(): NetworkData {
		const filterLinkedStates = (key: string | undefined, network: Network, filter: {[key:string]: StateData},
                                    parents: string []): {} => {
		    if (key && ! filter[key]) {
                const state = network.states.get(key);

                if (state) {
                    const stateData = state.serialise();

                    filter[key] = stateData;
                    if (stateData.parent && ! parents.includes(stateData.parent)) {
                        parents.push(stateData.parent);
                    }
                    stateData.transitions.forEach(transition =>
                        filterLinkedStates(transition.destination, network, filter, parents));
                    filterLinkedStates(stateData.child, network, filter, parents);
                }
            }
			return filter;
		};
		const registers: any = {};

        this.registers.forEach((register, key) => {
            registers[key] = register.serialise();
        });
        
        const parents: string[] = [];
        const linkedStates = filterLinkedStates(this.initial, this, {}, parents);
        const parentStates: {[key:string]: StateData} = {};

        parents.forEach(parentKey => {
            const parent = this.states.get(parentKey);
            
            if (parent) {
                parentStates[parentKey] = parent.serialise();
            }
        });
		return {
			initial: this.initial,
            registers,
			states: {
			    ...linkedStates,
                ...parentStates
            }
		};
	};
}